var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.65 35.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8c9091;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.06,33.4c-.42,0-.77-.34-.77-.76s.33-.78.76-.79c3.6-.06,7.02-1.47,9.61-3.97.31-.3.8-.29,1.1.02.3.31.29.8-.02,1.1-2.88,2.78-6.66,4.35-10.66,4.41h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.57,3.54c-.42,0-.77-.34-.77-.76s.34-.78.76-.79h.07c.06,0,.12,0,.18,0,.43,0,.77.35.77.77s-.35.77-.77.77h-.07c-.05,0-.1.01-.16.01h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.88,18.47c-.43,0-.77-.35-.77-.77,0-4.51,1.96-8.82,5.37-11.81.32-.28.81-.25,1.09.07s.25.81-.07,1.09c-3.07,2.7-4.84,6.58-4.84,10.64,0,.43-.35.77-.78.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.57,33.4h0c-4-.06-7.78-1.63-10.66-4.41-.31-.3-.32-.79-.02-1.1s.79-.32,1.1-.02c2.59,2.51,6,3.92,9.61,3.97.43,0,.77.36.76.79,0,.42-.35.76-.77.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.44,29.21c-.19,0-.39-.07-.54-.22-3.1-2.99-4.8-7-4.8-11.3,0-.43.35-.77.77-.77s.77.35.77.77c0,3.87,1.54,7.48,4.33,10.18.31.3.32.79.02,1.1-.15.16-.35.24-.56.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,33.41h-.26c-.43,0-.77-.37-.76-.8,0-.42.35-.76.77-.76h.25c.43,0,.77.35.77.78s-.35.77-.78.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,33.41c-.43,0-.77-.35-.77-.77s.35-.77.77-.77h.08s.1,0,.15,0c.4,0,.78.33.79.76,0,.43-.33.78-.76.79h-.07c-.06,0-.13,0-.19,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.66,7.24c-.18,0-.36-.06-.51-.19-2.52-2.21-5.75-3.46-9.1-3.51-.43,0-.77-.36-.76-.79,0-.43.35-.76.79-.76,3.71.06,7.3,1.44,10.1,3.9.32.28.35.77.07,1.09-.15.17-.37.26-.58.26h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.98,7.24c-.22,0-.43-.09-.58-.26-.28-.32-.25-.81.07-1.09,2.8-2.45,6.38-3.84,10.1-3.9.45-.02.78.33.79.76,0,.43-.33.78-.76.79-3.35.05-6.58,1.3-9.1,3.51-.15.13-.33.19-.51.19h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.06,3.54h-.24c-.43,0-.77-.35-.77-.78s.35-.77.77-.77h.25c.43,0,.77.36.76.79,0,.42-.35.76-.77.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.2,29.21c-.2,0-.41-.08-.56-.24-.3-.31-.29-.8.02-1.1,2.79-2.7,4.33-6.31,4.33-10.18,0-4.07-1.76-7.95-4.84-10.64-.32-.28-.35-.77-.07-1.09s.77-.35,1.09-.07c3.41,2.99,5.37,7.3,5.37,11.81s-1.71,8.3-4.8,11.3c-.15.15-.35.22-.54.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.42,9.72c-.13,0-.26-.03-.38-.1-.37-.21-.51-.68-.3-1.05,1.36-2.46,3.31-4.62,5.62-6.26.35-.25.83-.16,1.08.19.25.35.16.83-.19,1.08-2.13,1.5-3.91,3.49-5.16,5.75-.14.25-.41.4-.68.4h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,3.72c-.24,0-.48-.11-.63-.33-.25-.35-.16-.83.19-1.08l.09-.07c.05-.04.11-.08.16-.12.35-.24.83-.15,1.08.2s.15.84-.2,1.08c-.03.02-.06.05-.09.07-.05.04-.09.07-.14.11-.14.1-.29.14-.45.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.03,26.43c-.29,0-.56-.16-.7-.43-1.29-2.62-1.95-5.41-1.95-8.3,0-.43.35-.77.77-.77s.77.35.77.77c0,2.65.6,5.21,1.79,7.61.19.38.03.85-.35,1.04-.11.05-.23.08-.34.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.06,33.4c-.15,0-.3-.04-.43-.13-.06-.04-.12-.08-.17-.13l-.08-.06c-.35-.25-.43-.73-.19-1.08.25-.35.73-.43,1.08-.19.05.03.09.07.14.1.03.02.06.05.09.07.35.24.45.72.21,1.08-.15.22-.39.34-.64.34h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,33.22c-.16,0-.31-.05-.45-.14-2.56-1.81-4.65-4.26-6.04-7.08-.19-.38-.03-.85.35-1.04.38-.19.85-.03,1.04.35,1.27,2.59,3.19,4.84,5.54,6.5.35.25.43.73.19,1.08-.15.21-.39.33-.63.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.16,18.47c-.43,0-.77-.35-.77-.77,0-3.18.82-6.34,2.36-9.12.21-.37.68-.51,1.05-.3.37.21.51.68.3,1.05-1.42,2.55-2.17,5.45-2.17,8.37,0,.43-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.42,9.72c-.09,0-.18-.02-.26-.05-1.7-.62-3.27-1.49-4.66-2.6-.33-.27-.39-.75-.12-1.09.27-.33.75-.39,1.09-.12,1.26,1,2.69,1.8,4.23,2.36.4.15.61.59.46.99-.11.32-.41.51-.73.51h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.21,9.72c-.32,0-.61-.2-.73-.51-.15-.4.06-.85.46-.99,1.54-.56,2.97-1.35,4.23-2.36.34-.27.82-.21,1.09.12.27.33.21.82-.12,1.09-1.4,1.11-2.97,1.98-4.66,2.6-.09.03-.18.05-.26.05h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,10.69c-.43,0-.77-.35-.77-.77s.35-.77.77-.77c1.73,0,3.45-.31,5.13-.92.4-.15.85.06.99.46.15.4-.06.85-.46.99-1.85.67-3.75,1.01-5.66,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,10.69c-1.91,0-3.81-.34-5.66-1.01-.4-.15-.61-.59-.46-.99s.59-.61.99-.46c1.68.61,3.4.92,5.13.92.43,0,.77.35.77.77s-.35.78-.77.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.19,29.21c-.18,0-.36-.06-.51-.19-1.3-1.13-2.76-2.02-4.36-2.65-.4-.16-.59-.61-.44-1,.16-.4.61-.59,1-.44,1.76.69,3.38,1.68,4.81,2.92.32.28.36.77.08,1.09-.15.18-.37.27-.59.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.61,26.43c-.09,0-.19-.02-.28-.05-1.78-.7-3.63-1.05-5.51-1.05-.43,0-.77-.35-.77-.77s.35-.77.77-.77c2.07,0,4.12.39,6.08,1.16.4.16.59.61.44,1-.12.31-.41.49-.72.49h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.03,26.43c-.31,0-.6-.19-.72-.49-.16-.4.04-.85.44-1,1.96-.77,4-1.16,6.08-1.16.43,0,.77.35.77.77s-.35.77-.77.77c-1.88,0-3.73.35-5.51,1.05-.09.04-.19.05-.28.05h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.44,29.21c-.22,0-.43-.09-.59-.27-.28-.32-.25-.81.08-1.09,1.43-1.24,3.05-2.23,4.81-2.92.4-.16.85.04,1,.44.16.4-.04.85-.44,1-1.6.63-3.06,1.52-4.36,2.65-.15.13-.33.19-.51.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.47,18.47c-.43,0-.77-.35-.77-.77,0-2.92-.75-5.82-2.17-8.37-.21-.37-.07-.85.3-1.05.37-.21.85-.07,1.05.3,1.54,2.78,2.36,5.94,2.36,9.12,0,.43-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,3.72c-.15,0-.31-.05-.44-.14-.05-.04-.1-.07-.15-.11-.03-.02-.06-.05-.09-.07-.35-.24-.44-.73-.2-1.08s.72-.44,1.08-.2c.05.04.11.08.16.12l.09.07c.35.24.44.73.19,1.08-.15.22-.39.33-.64.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.57,33.4c-.25,0-.49-.12-.64-.34-.24-.35-.15-.84.21-1.08.03-.02.06-.04.09-.07.05-.04.1-.08.15-.11.35-.24.83-.16,1.08.19.24.35.16.83-.19,1.08l-.08.06c-.06.04-.11.09-.17.12-.13.09-.28.13-.43.13l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.61,26.43c-.12,0-.23-.03-.34-.08-.38-.19-.54-.65-.35-1.04,1.18-2.41,1.79-4.97,1.79-7.61,0-.43.35-.77.77-.77s.77.35.77.77c0,2.88-.65,5.68-1.95,8.3-.13.27-.41.43-.7.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,33.22c-.24,0-.48-.11-.63-.33-.25-.35-.16-.83.19-1.08,2.35-1.66,4.27-3.91,5.54-6.5.19-.38.65-.54,1.04-.35.38.19.54.65.35,1.04-1.39,2.82-3.48,5.27-6.04,7.08-.14.1-.29.14-.45.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.21,9.72c-.27,0-.54-.14-.68-.4-1.25-2.25-3.04-4.24-5.16-5.75-.35-.25-.43-.73-.19-1.08.25-.35.73-.43,1.08-.19,2.32,1.64,4.26,3.8,5.62,6.26.21.37.07.85-.3,1.05-.12.07-.25.1-.38.1h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.16,18.47H3.87c-.43,0-.77-.35-.77-.77s.35-.77.77-.77h7.29c.43,0,.77.35.77.77s-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.47,18.47h-7.66c-.43,0-.77-.35-.77-.77s.35-.77.77-.77h7.66c.43,0,.77.35.77.77s-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,18.47h-7.66c-.43,0-.77-.35-.77-.77s.35-.77.77-.77h7.66c.43,0,.77.35.77.77s-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.32,18.47h-6.84c-.43,0-.77-.35-.77-.77s.35-.77.77-.77h6.84c.43,0,.77.35.77.77s-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,10.69c-.43,0-.77-.35-.77-.77V2.95c0-.43.35-.77.77-.77s.77.35.77.77v6.97c0,.43-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,18.47c-.43,0-.77-.35-.77-.77v-7.78c0-.43.35-.77.77-.77s.77.35.77.77v7.78c0,.43-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,33.22c-.43,0-.77-.35-.77-.77v-7.9c0-.43.35-.77.77-.77s.77.35.77.77v7.9c0,.43-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,3.72c-.43,0-.77-.35-.77-.77v-.19c0-.43.35-.77.77-.77s.77.35.77.77v.19c0,.43-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,25.32c-.43,0-.77-.35-.77-.77v-6.85c0-.43.35-.77.77-.77s.77.35.77.77v6.85c0,.43-.35.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,33.41c-.43,0-.77-.35-.77-.77v-.19c0-.43.35-.77.77-.77s.77.35.77.77v.19c0,.43-.35.77-.77.77Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.542ec61016511395b08ca5679f0a6706.svg";
export { ForwardRef as ReactComponent };